import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { AssetDriverListComponent } from './assets-driver-list/asset-driver-list.component';
import { AssetDriverDetailComponent } from './asset-driver-detail/asset-driver-detail.component';
import { AssetDetailComponent } from '../my-assets/asset-detail/asset-detail.component';

const routes: Routes = [
  {
    path: 'asset-driver-list',
    canActivate: [AuthorizeGuard], //RightsGuard
    children: [
      { path: '', component: AssetDriverListComponent },
      { path: ':id', component: AssetDriverDetailComponent },
      { path: 'journey/:id', component: AssetDetailComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AssetsDriverRoutingModule {}
